
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../store/httpClient";
const Chart = require("chart.js");

@Component
export default class FeedbackDiagramComponent extends Vue {
	private loading: boolean = false;
	private fragen: any = [];
	private mounted() {
		this.loadData();
	}

	private get fragenWithAnswers() {
		return this.fragen.filter((f: any) => f.antworten.length > 0);
	}

	private updateDiagram() {
		const labels = this.fragen.map((f: any) => "..." + f.text + " (" + f.anzahl + ")");
		// console.log(this.fragen);
		const werte = this.fragen.map((f: any) => {
			return f.value / f.anzahl;
		});

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		const chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "horizontalBar",

			// The data for our dataset
			data: {
				labels,
				datasets: [
					{
						label: "Wert",
						borderColor: "rgb(255, 255, 255)",
						backgroundColor: "#EFBB20",
						borderWidth: { left: 0, right: 0, top: 0, bottom: 0 },
						data: werte,
					},
				],
			},

			// Configuration options go here
			options: {
				legend: {
					display: false,
				},
				scales: {
					xAxes: [
						{
							ticks: {
								min: 0,
								max: 5,
								stepSize: 1,
							},
						},
					],
					yAxes: [
						{
							afterFit: (scaleInstance: any) => {
								scaleInstance.width = 250; // sets the width to 100px
							},
						},
					],
				},
			},
		});
		chart.options.scales.yAxes[0].ticks.fontSize = 14;
		chart.update();
	}
	private async loadData() {
		try {
			this.loading = true;
			const response = await httpClient().get(`Report/GetFeedbackReport`);
			this.fragen = response.data;
			this.updateDiagram();
		} catch {
			console.log("Load orders failed.");
		} finally {
			this.loading = false;
		}
	}
}
